/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useCallback, useEffect, useState } from 'react';
import { AppBar, Grid, IconButton, Toolbar } from '@material-ui/core';
import { useStyles } from './styles';
import { NotificationsMenu } from '../NotificationsMenu';
import { getTranslations } from '../../layouts';
import { languages } from '../../utils';
import { trackAmplitudeData } from '../../services/amplitudeService';
import { SelectLanguageDialog } from '../../layouts/default/SelectLanguageDialog';
import { useApiError, useAppData, useLoading } from '../../providers';

interface Props {
  title: string;
}

export const Header: FC<Props> = ({ title }) => {
  const classes = useStyles();
  const { setIsLoading } = useLoading();
  const { addError } = useApiError();
  const { saveTranslations, saveLocale, locale } = useAppData();
  const [translation, setTranslation] = useState<any>('');
  const [selectedLocale, setSelectedLocale] = useState<any>(languages[0]);
  const [openLanguageDialog, setOpenLanguageDialog] = useState(false);

  useEffect(() => {
    if (locale) {
      const selectedLanguage = languages.find((item) => item.value === locale) || languages[0];
      setSelectedLocale(selectedLanguage);
    }
  }, []);

  const getTranslationList = useCallback(
    async (newLocale: string) => {
      try {
        setIsLoading(true);
        const translations = await getTranslations();
        saveTranslations(JSON.stringify(translations.data));
        saveLocale(newLocale);
        setTranslation(translations.data);
      } catch (error) {
        addError(JSON.stringify(error.response));
      } finally {
        setIsLoading(false);
      }
    },
    [saveTranslations, saveLocale, addError, setIsLoading],
  );

  const handleLocaleChange = useCallback(
    async (value: string) => {
      setOpenLanguageDialog(false);
      const selectedLanguage = languages.find((item) => item.value === value) || languages[0];
      setSelectedLocale(selectedLanguage);
      saveLocale(selectedLanguage.value);
      if (selectedLanguage.value !== languages[0].value) {
        trackAmplitudeData('partnerPortal_action_languageChanged', {
          page_language: selectedLanguage.value,
        });
      }
      await getTranslationList(selectedLanguage.value);
    },
    [getTranslationList, saveLocale],
  );

  return (
    <Grid container direction="row" className={classes.header}>
      <AppBar position="sticky" className={classes.appBarShift}>
        <Toolbar className={classes.toolbar}>
          <Grid item className={classes.title}>
            {title}
          </Grid>
          <Grid className={classes.headerSpace} />
          <Grid item>
            <NotificationsMenu />
          </Grid>
          <IconButton
            className={classes.btn}
            onClick={() => {
              setOpenLanguageDialog(true);
            }}
          >
            {selectedLocale.icon}
          </IconButton>
        </Toolbar>
      </AppBar>
      <SelectLanguageDialog selectedValue={selectedLocale.label} open={openLanguageDialog} onChange={handleLocaleChange} onClose={() => setOpenLanguageDialog(false)} translation={translation} />
    </Grid>
  );
};
